import { atom } from "jotai";

export const recommendedEngineersListAtom = atom<number[]>([]);

recommendedEngineersListAtom.debugLabel = "Recommended Engineers List Atom";
